var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "helper" } },
    [
      _c(
        "div",
        { staticClass: "con-box" },
        [
          _c("main-header"),
          _c(
            "div",
            { staticClass: "helper-main" },
            [
              _c("help-left"),
              _c("div", { staticClass: "help-main" }, [_c("nuxt")], 1)
            ],
            1
          )
        ],
        1
      ),
      _c("main-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14bc9d02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14bc9d02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/helper.vue
// module id = sOSe
// module chunks = 1